<div class="bms-theme tabs-and-actions-header">
  <vdw-tabs-menu [menuItems]="menuItems" [selectedMenuItem]="selectedMenuItem" (selectedMenuItemChange)="selectedMenuItemChange.emit($event)" />

  <div class="action-buttons-container">
    <ng-content />
  </div>
</div>
